module.exports = __webpack_public_path__ + "static/media/Subtract.4d08a1c5.png";